import React, { Component } from 'react';
import getLabel from './../../../utils/labels'

class Typing extends Component {
  render() {
    return (
      <div className="typing-box">
        <span className="chat-text">{getLabel('label_speaking')}</span>
      </div>
    );

  }
}

export default Typing;



// WEBPACK FOOTER //
// /src/call/container/typing/typing.js